import { useState } from "react";
import styled from "styled-components";

import NavItem from "./NavItem";
import SettingsButton from "./SettingsButton";
import {
  SectionTabBar,
  SectionTabButton,
  SectionTabBarWrapper,
} from "./SectionTabBar";

export default function Giving() {
  const [selectedItem, setSelectedItem] = useState(false);
  return (
    <Wrapper>
      <SectionTabBarWrapper>
        <SectionTabBar>
          <SectionTabButton
            icon="fa-solid fa-chart-pie-simple-circle-dollar"
            title="Summary"
            itemKey="famreg"
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
          />
          <SectionTabButton
            icon="fa-solid fa-money-bills"
            title="Batches"
            itemKey="famreg"
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
          />
          <SectionTabButton
            icon="fa-solid fa-hand-holding-circle-dollar"
            title="Campaigns"
            itemKey="famreg"
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
          />
          <SectionTabButton
            icon="fa-solid fa-upload"
            title="Import Gifts"
            itemKey="famreg"
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
          />
          <SectionTabButton
            icon="fa-solid fa-landmark-dome"
            title="Donor Letters"
            itemKey="famreg"
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
          />
        </SectionTabBar>
      </SectionTabBarWrapper>

      <NavItem
        icon="fa-duotone fa-solid fa-check"
        title="Fund"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
      />
      <NavItem
        icon="fa-duotone fa-solid fa-check"
        title="Fund"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
      />
      <NavItem
        icon="fa-duotone fa-solid fa-check"
        title="Fund"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
      />
      <NavItem
        icon="fa-duotone fa-solid fa-check"
        title="Fund"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
      />
      <NavItem
        icon="fa-duotone fa-solid fa-check"
        title="Fund"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-bottom: 12px;
  position: relative;
`;
